export { default } from "./GuidedHighlightingStudentSkillQuestion";
